<template>
  <div id="rg-object-history-player" v-if="showRgHistoryPlayer">
    <rg-object-history-map
      v-if="isSetUpFinished"
      mapId="rg-object-history-player-map"
      :mapSetting="mapSetting"
      :mapStyle="mapStyle"
      :updateMapStyle="updateMapStyle"
      :isMobileDevice="isMobileDevice"
      :textLayerIds="textLayerIds"
      :mapLocale="mapLocale"
      :showPrivatePlot="showPrivatePlot"
    ></rg-object-history-map>
  </div>
</template>

<script>
import * as turf from "@turf/turf";

import {
  MAP_DEFAULT_POSITION,
  MAP_STYLE_DEFAULT,
  MAP_STYLE_SATELLITE,
} from "@/config/const";

import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import C from "./Constants";
import { LocalizeMixin, DeviceInfoMixin } from "@/mixins";
// components
import RgObjectHistoryMap from "./RgObjectHistoryMap.vue";

// Store
import { mapGetters } from "vuex";

export default {
  name: "RgObjectHistoryPlayer",
  mixins: [LocalizeMixin, DeviceInfoMixin],
  components: { RgObjectHistoryMap },
  data() {
    return {
      isSetUpFinished: false,
      mapStyle: "",
      pos: null,
    };
  },
  computed: {
    ...mapGetters({
      getAddonFlag: "getAddonFlag",
    }),
    showRgHistoryPlayer() {
      return this.getAddonFlag("GKMG_RADAR_GRID");
    },
    showPrivatePlot() {
      return this.getAddonFlag("GKMG_PRIVATE_PLOT");
    },
    mapSetting() {
      let polygon = turf.polygon([C.PLAYBACK_AREA_COORDINATES]);
      let center = turf.centerOfMass(polygon).geometry.coordinates;
      return {
        container: "rg-object-history-player-map",
        style: this.mapStyle,
        center: center,
        zoom: C.PLAYBACK_AREA_DEFAULT_ZOOM,
        doubleClickZoom: false,
        maxZoom: 18,
        attributionControl: false,
        localIdeographFontFamily: "'Noto Sans', sans-serif",
      };
    },
    mapZoom() {
      if (!this.pos) return MAP_DEFAULT_POSITION.zoom;
      if (!this.pos.zoom) return MAP_DEFAULT_POSITION.zoom;
      return this.pos.zoom;
    },
    isMobileDevice() {
      // NOTE: 現状、ユーザエージェントでモバイル判定
      return ["iPhone", "iPad"].includes(this.getDeviceInfo().deviceType);
    },
    textLayerIds() {
      return this.getTextLayerIds();
    },
    mapLocale() {
      return "name_" + this.getBrowserLanguage();
    },
  },
  methods: {
    async setUp() {
      this.mapStyle = await LocalDbService.getMapStyle();
      this.pos = await LocalDbService.getDefaultPosition();
      return true;
    },
    setRouterViewStyle() {
      const routerViewClass = document.getElementsByClassName("router-view");
      const prevCssText = routerViewClass[0].cssText;
      routerViewClass[0].style.setProperty("padding", "0.0rem", "important");
      return prevCssText;
    },
    updateMapStyle() {
      if (this.mapStyle === MAP_STYLE_DEFAULT) {
        this.mapStyle = MAP_STYLE_SATELLITE;
        FireStoreService.saveMapStyle(MAP_STYLE_SATELLITE);
        LocalDbService.saveMapStyle(MAP_STYLE_SATELLITE);
      } else {
        this.mapStyle = MAP_STYLE_DEFAULT;
        FireStoreService.saveMapStyle(MAP_STYLE_DEFAULT);
        LocalDbService.saveMapStyle(MAP_STYLE_DEFAULT);
      }
    },
  },
  async created() {
    this.isSetUpFinished = await this.setUp();
  },
};
</script>

<style lang="scss">
.router-view {
  &:has(#rg-object-history-player) {
    padding: 0rem !important;
  }
}
</style>

<style lang="scss" scoped></style>
